import { useEffect } from 'react';

import { getRequestId } from 'core/services/bff';

export const CLEAR_SALE_APPKEY = 109191;

export const ClearSaleScript = () => {
  useEffect(() => {
    const bodyElement = document.querySelector('body');
    const scriptTag = document.createElement('noscript');
    const imgTag = document.createElement('img');

    imgTag.setAttribute(
      'src',
      `https://device.clearsale.com.br/p/fp.png?sid=${getRequestId()}&app=${CLEAR_SALE_APPKEY}&ns=1`,
    );

    scriptTag.appendChild(imgTag);
    bodyElement?.appendChild(scriptTag);
  }, []);

  return <></>;
};
